import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import OrderItemsGroup from './OrderItemsGroup';
import { getItemType, productTypeApps } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const mailboxProducts = ['mailbox', 'mailboxv2'];
const productTypesMultiple = [...mailboxProducts];
function filterDiscounts(item) {
  return item.item_type !== 'discount';
}
function filterMailboxDiscount(item) {
  // T108498 : before the invoice is edited and stored in db, typeof discounts are fees
  return !(item.item_type === 'fees' && item.product_type === 'mailboxv2');
}
function filterOutSimpleHostingDiscount(item) {
  return !(item.product_type === 'paas' && item.action_name === 'create' && !item.details?.product_uuid && item.price_before_taxes < 0);
}
function filterOutSimpleHostingRelease(item) {
  return !(item.product_type === 'paas' && item.action_name === 'release');
}
function filterOutBaseKitDelete(item) {
  return !(item.product_type === 'sites' && item.action_name === 'delete');
}
function filterDiscarded(item) {
  return filterDiscounts(item) && filterMailboxDiscount(item) && filterOutSimpleHostingDiscount(item) && filterOutSimpleHostingRelease(item) && filterOutBaseKitDelete(item);
}
export function sortProductTypesGroups(
// $FlowFixMe[deprecated-utility]
a,
// $FlowFixMe[deprecated-utility]
b) {
  if (a.name === 'domains') return -1;
  if (b.name === 'domains') return 1;
  if (a.name === 'certificates') return -1;
  if (b.name === 'certificates') return 1;
  if (a.name.startsWith('oneClick')) return -1;
  if (b.name.startsWith('oneClick')) return 1;
  if (a.name === 'paas') return -1;
  if (b.name === 'paas') return 1;
  if (a.name === 'iaas') return -1;
  if (b.name === 'iaas') return 1;
  return 0;
}
// $FlowFixMe[missing-local-annot]
const countIdenticalItems = (acc, item) => {
  if (productTypesMultiple.indexOf(item.product_type) > -1) {
    const productMultiple = acc.filter(item_ => item_.product_type === item.product_type && item_.action_name === item.action_name)[0];
    if (productMultiple) {
      productMultiple.quantity += 1;
    } else {
      acc.push({
        ...item,
        quantity: 1
      });
    }
  } else {
    acc.push(item);
  }
  return acc;
};

// $FlowFixMe[unsupported-syntax]
export default function OrderItems(props) {
  const {
    __
  } = useTranslator();
  const productTypeLabels = {
    domains: __('Domains'),
    certificates: __('SSL Certificates'),
    paas: __('Simple Hosting'),
    webhostingCreation: __('Hosting creation'),
    webhostingRenewal: __('Hosting renewal'),
    webhostingUpdate: __('Hosting update'),
    oneClickCreation: __('Web Hosting Pack creation'),
    oneClickRenewal: __('Web Hosting Pack renewal'),
    iaas: __('Cloud'),
    services: __('Services'),
    'mailbox-standalone': __('Mailbox services')
  };
  const {
    order
  } = props;
  const items = order.items.filter(filterDiscarded);
  const productTypes = [...new Set(items.map(getItemType)
  // $FlowFixMe[invalid-computed-prop]
  .filter(productType => productTypeLabels[productType]))];
  const productTypesGroups = productTypes.map(name => {
    const groupItems = items.filter(item => getItemType(item) === name).reduce(countIdenticalItems, []);
    return {
      name,
      // $FlowFixMe[invalid-computed-prop]
      app: productTypeApps[name],
      // $FlowFixMe[invalid-computed-prop]
      label: productTypeLabels[name],
      items: groupItems
    };
  }).sort(sortProductTypesGroups);

  // $FlowFixMe[missing-local-annot]
  return productTypesGroups.map(group => /*#__PURE__*/_jsx(OrderItemsGroup, {
    group: group
  }, group.name));
}